import { useState } from 'react';
import React from 'react';

import { LargePlay } from '@lyearn/icons';
import VideoPlayer from '@lyearn/shared/components/Players';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

import { MediaSize } from '../../types';
import { videoStyles } from '../styles';
import { GridRenderProps } from '../types';
import { getDurationText } from '../utils';

const GridVideo: React.FC<GridRenderProps> = ({
  media: { url, previewUrl },
  size,
  playInline,
  className,
}) => {
  const [videoDuration, setVideoDuration] = useState<number>();

  if (playInline) {
    return (
      <Stack className={cn(videoStyles, 'h-full w-full overflow-hidden rounded-8')}>
        <VideoPlayer provider="html5" url={url!} />
      </Stack>
    );
  }

  const videoClasses = cn(
    className,
    { 'w-96 h-96': size === MediaSize.SMALL },
    { 'h-256': size === MediaSize.LARGE },
    { 'h-auto': size === MediaSize.AUTO },
    size === MediaSize.ADJUST ? 'w-full h-full' : '',
  );

  const showVideoDuration = size !== MediaSize.SMALL;
  const durationText = getDurationText(videoDuration!);

  return (
    <Box className="relative h-full w-full xs:h-full xs:w-full">
      <video
        className={videoClasses}
        poster={previewUrl!}
        src={url!}
        onLoadedMetadata={
          showVideoDuration
            ? (event) => {
                setVideoDuration(event.currentTarget.duration);
              }
            : undefined
        }
      />
      <Box className="absolute top-0 bottom-0 h-full w-full rounded-8 bg-interactive-primary opacity-25 end-0 start-0" />
      <LargePlay
        className={cn(
          'absolute top-1/2 -translate-x-1/2 -translate-y-1/2 transform start-1/2 rtl:translate-x-1/2',
          size === MediaSize.SMALL ? 'h-24 w-24' : 'h-48 w-48',
        )}
        fillColorToken="icon-white"
      />
      {showVideoDuration ? (
        <Box className="absolute bottom-12 rounded-4 bg-interactive-blur px-4 py-2 start-12">
          <Typography color="text-text-white" variant="label-caps">
            {durationText}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default React.memo(GridVideo);
